import { render, staticRenderFns } from "./resolveEdit.vue?vue&type=template&id=a3a96be8"
import script from "./resolveEdit.vue?vue&type=script&lang=js"
export * from "./resolveEdit.vue?vue&type=script&lang=js"
import style0 from "./resolveEdit.vue?vue&type=style&index=0&id=a3a96be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports